export default "__VITE_ASSET__088aa306__"